import type { ResellerTld } from "@kilat/contracts/reseller-pricing";
import { useMutation } from "@tanstack/react-query";
import { setTldEnabled } from "../api";
import { pricingKeys } from "../queries";

// The answer is the TLD as the list shows it: it replaces that row in the cached list.
export const useSetTldEnabled = (tldId: string) =>
  useMutation({
    mutationFn: (enabled: boolean) => setTldEnabled(tldId, { enabled }),
    onSuccess: ({ data }, _enabled, _result, { client }) => {
      client.setQueryData(pricingKeys.tlds(), (list: ResellerTld[] | undefined) =>
        list?.map((tld) => (tld.id === data.id ? data : tld)),
      );
    },
  });
